import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import CardText from '../../components/cardText';
import Footer from '../../components/footer';
import Header from '../../components/header';
import HeaderNav from '../../components/headerNav';
import i18n from '../../utils/translate';

const PoliticaPrivacidade = (): JSX.Element => {
  const b_containerName = 'politica_privacidade';
  const { t } = useTranslation();
  return (
    <>
      <Helmet htmlAttributes={{ lang: i18n.language }}>
        <title>
          {t('Política de Privacidade - Play2sell - Gamificação para Vendas')}
        </title>
        <meta
          name='description'
          content='Em vigor a partir de: 03 de agosto de 2020.'
        />
        <meta
          name='robots'
          content='follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large'
        />
        <link rel='canonical' href='https://play2sell.com/privacy-policy/' />
        <meta property='og:type' content='article' />
        <meta
          property='og:title'
          content='Política de Privacidade - Play2sell - Gamificação para Vendas'
        />
        <meta
          property='og:description'
          content='Em vigor a partir de: 03 de agosto de 2020.'
        />
        <meta
          property='og:url'
          content='https://play2sell.com/privacy-policy/'
        />
        <meta
          property='article:publisher'
          content='https://www.facebook.com/play2sell/'
        />
        <meta property='og:updated_time' content='2020-11-17T14:46:46-03:00' />
        <meta
          name='twitter:title'
          content='Política de Privacidade - Play2sell - Gamificação para Vendas'
        />
        <meta
          name='twitter:description'
          content='Em vigor a partir de: 03 de agosto de 2020.'
        />
      </Helmet>
      <HeaderNav />
      <Header
        b_container={b_containerName}
        title={t('Política de Privacidade')}
        subtitulo={t('Política de Privacidade')}
      />
      <main className='container-main'>
        <CardText
          b_container={b_containerName}
          b_str='1'
          text={
            t(
              'Em vigor a partir de: <b>03 de agosto de 2020.</b>\n\nEsta Política de Privacidade compreende'
            ) + ':'
          }
          list={[
            t(
              'As formas, como e por que, coletamos seus dados pessoais e sua imagem, em caso de usuário pessoa física;'
            ),
            t(
              'As formas, como e por que, coletamos os dados, marca e logo da sua empresa, em caso de usuário pessoa jurídica;'
            ),
            t('As opções que você tem sobre seus dados e imagem.')
          ]}
        />
        <CardText
          b_container={b_containerName}
          b_str='2'
          text={
            t(
              'Esta Política de Privacidade se aplica aos jogos, aplicativos, sites e serviços relacionados da Play2sell, os quais chamamos coletivamente de Serviço. Podemos atualizar periodicamente esta Política de Privacidade, publicando uma nova versão no site da Play2sell. Se realizarmos qualquer alteração material, nós o notificaremos por meio de um aviso no Serviço antes da alteração entrar em vigor. Seu uso continuado do Serviço após a data de vigência estará sujeito à nova Política de Privacidade.'
            ) || ''
          }
        />
        <CardText
          b_container={b_containerName}
          b_str='3'
          title={t('ENTRE EM CONTATO CONOSCO') || ''}
          text={
            t(
              'Caso tenha dúvidas sobre a proteção de dados ou se tiver algum pedido para resolver problemas com seus dados pessoais, ou com os dados da sua empresa, caso o usuário seja pessoa jurídica, recomendamos que entre em contato primeiramente por meio do jogo para que possamos lhe responder com mais rapidez.\n\nNome do controlador:\n\nPlay2sell\n\nEndereço: Rua Gomes de Carvalho, 911\n\n4° andar - Sala 412, Vila Olimpia, São Paulo - SP, 04547-003\n\nE-mail: contato@play2sell.com'
            ) || ''
          }
        />
        <CardText
          b_container={b_containerName}
          b_str='4'
          title={t('OS DADOS QUE COLETAMOS') || ''}
          text={t('<b>Dados que você nos fornece:</b>') || ''}
          list={[
            t('Informações de contato, como nome e endereço de e-mail;'),
            t('Nome do jogador e senha;'),
            t('Informações inseridas no seu perfil na plataforma;'),
            t(
              'Suas mensagens para o Serviço, como registros de bate-papo e tickets de suporte ao jogador;'
            ),
            t('Sua imagem e foto de perfil, em caso de usuário pessoa física;'),
            t('Marca, logo/case em caso usuário pessoa jurídica;'),
            t(
              'Outros dados que você opta por nos fornecer, como, por exemplo, dados para identificar uma conta perdida.'
            )
          ]}
        />
        <CardText
          b_container={b_containerName}
          b_str='5'
          text={t('<b>Dados que coletamos automaticamente:</b>') || ''}
          list={[
            t('Dados sobre sua conta e progresso do jogo;'),
            t(
              'Seu endereço de IP e identificadores de dispositivos móveis (como o ID do dispositivo, o código de publicidade, o endereço MAC, o IMEI);'
            ),
            t(
              'Dados sobre o seu dispositivo, como nome e sistema operacional do dispositivo, tipo de navegador e idioma;'
            ),
            t(
              'Dados que coletamos com cookies e tecnologias semelhantes (veja mais abaixo);'
            ),
            t('Dados gerais de localização;'),
            t(
              'Dados precisos de geolocalização (GPS, com seu consentimento); e'
            ),
            t(
              'Dados sobre seu uso do Serviço, como dados de jogabilidade e suas interações com outros jogadores dentro do Serviço.'
            )
          ]}
        />
        <CardText
          b_container={b_containerName}
          b_str='6'
          text={t('<b>Dados que coletamos dos parceiros:</b>') || ''}
          list={[
            t(
              'Dados que recebemos se você vincular uma ferramenta de terceiros ao Serviço (como Facebook ou Google);'
            ),
            t(
              'Dados demográficos (como para determinar a localização aproximada do seu endereço IP);'
            ),
            t(
              'Dados para combater fraudes (como abuso de reembolso nos jogos ou cliques fraudulentos em publicidade);'
            ),
            t(
              'Dados das plataformas nas quais os jogos são executados (por exemplo, para verificar o pagamento); e'
            ),
            t(
              'Dados para fins de publicidade e análise, para que possamos fornecer um serviço melhor.'
            )
          ]}
        />
        <CardText
          b_container={b_containerName}
          b_str='7'
          title={`${t('POR QUE COLETAMOS SEUS DADOS')}:`}
          text={`${t(
            '<b>Para que o Serviço possa funcionar.</b>\n\nPara executar o contrato, processamos os dados necessários para'
          )}:`}
          list={[
            t(
              'Criar contas e permitir que você jogue nossos jogos e use nosso serviço;'
            ),
            t('Operar o serviço;'),
            t('Verificar e confirmar pagamentos;'),
            t('Fornecer os produtos e serviços solicitados; e'),
            t('Enviar comunicações relacionadas ao Serviço.')
          ]}
        />
        <CardText
          b_container={b_containerName}
          b_str='8'
          text={`${t(
            '<b>Para fazer com que o Serviço seja mais adequado para nossos jogadores.</b>\n\nPara oferecer um Serviço excelente aos nossos jogadores, temos o interesse legítimo para coletar e processar os dados necessários para'
          )}:`}
          list={[
            t('Atualizar e desenvolver perfis de jogadores;'),
            t('Desenvolver e melhorar o Serviço e a experiência do jogador;'),
            t('Gerenciar nosso relacionamento com você;'),
            t('Fornecer recursos sociais como parte do Serviço;'),
            t('Personalizar sua experiência com o Serviço;'),
            t(
              'Responder aos seus comentários e perguntas e oferecer atendimento ao jogador;'
            ),
            t(
              'Fornecer ofertas da Play2sell no Serviço, bem como em outros sites e serviços, por e-mail e SMS;'
            ),
            t(
              'Enviar informações relacionadas, como atualizações, alertas de segurança e mensagens de suporte;'
            ),
            t('Permitir que você se comunique com outros jogadores; e'),
            t(
              'Dar oportunidade aos usuários de receberem convites dos nossos parceiros para fazer parte da equipe.'
            )
          ]}
        />
        <CardText
          b_container={b_containerName}
          b_str='9'
          text={
            t(
              '<b>Para mostrar anúncios personalizados.</b>\n\nPara mostrar anúncios personalizados no Serviço, bem como em outros sites e serviços (incluindo e-mail e SMS), temos o interesse legítimo de processar os dados necessários para'
            ) || ''
          }
          list={[
            t(
              'Acompanhar o conteúdo que você acessa em conexão com o Serviço e seu comportamento on-line; e'
            ),
            t('Fornecer, direcionar e melhorar nossa publicidade e o Serviço.')
          ]}
        />
        <CardText
          b_container={b_containerName}
          b_str='10'
          text={
            t(
              'Para obter informações sobre como excluir anúncios personalizados, consulte a seção “Seus direitos e opções” abaixo.\n\n<b>Para divulgação da Play2sell.</b>\n\nEm caso de usuário pessoa física, você desde já autoriza a divulgação da sua imagem, nome e da sua foto de perfil e, em caso de usuário pessoa jurídica, você desde já autoriza a divulgação da sua imagem, marca e logo para a gravação de vídeos de divulgação, anúncios, folders, mensagens eletrônicas, no website da Play2sell e de todos os seus parceiros, bem como em todas as redes sociais e plataformas de comunicação como Instagram, Facebook, Linkedin, Youtube e e-mail, tudo relativo ao objeto do Termo de Uso.\n\nNeste ato, você autoriza, expressa ser sua vontade e declara sua autorização pelo uso acima descrito, sem que nada possa ser reclamado, a qualquer tempo durante a vigência desta Política de Privacidade, a título de direitos conexos a sua imagem ou de qualquer outro Usuário.\n\nA autorização é concedida a título gratuito, abrangendo o uso da imagem em todo território nacional e no exterior, pelo prazo de 5 anos.\n\nA qualquer momento, você pode revogar a presente autorização e, para tanto, você deverá cessar o uso dos jogos, aplicativos, sites e serviços, seguindo o caminho disposto nos Termos de Uso e informar a Play2sell imediatamente de sua decisão de cessação de utilizar a plataforma, para que a Play2sell possa tomar as devidas providências de sustação de uso da imagem e da substituição de sua imagem.\n\n<b>Para manter o Serviço seguro e justo.</b>\n\nGarantir as condições equitativas no Serviço é uma prioridade para nós. Para mais informações sobre nossa política de uso aceitável, consulte os <a href="/terms-of-use">Termos de Serviço da Play2sell</a>, em caso de usuário pessoa física, ou o <b>Contrato de Licença de Uso de Software</b>, em caso de usuário pessoa jurídica.\n\nA fim de manter o Serviço e seus recursos sociais seguros e justos, para combater fraudes e, do contrário, garantir o uso aceitável, temos um interesse legítimo em processar os dados necessários para'
            ) || ''
          }
          list={[
            t('Analisar e monitorar o uso do Serviço e seus recursos sociais;'),
            t('Moderar conversas automática ou manualmente; e'),
            t(
              'Tomar medidas contra jogadores fraudulentos e/ou malcomportados.'
            )
          ]}
        />
        <CardText
          b_container={b_containerName}
          b_str='11'
          text={
            t(
              '<b>Para analisar, perfilar e segmentar.</b>\n\nEm todos os casos e propósitos acima, podemos analisar, perfilar e segmentar todos os dados coletados.\n\n<b>Ranking</b>\n\nA Play2sell se reserva no direito de disponibilizar no aplicativo (APP), de forma pública, a todos jogadores o ranking de resultados. Dessa forma, todos usuários terão acesso a sua posição no ranking (seja uma posição alta ou baixa), bem como a sua pontuação.\n\nSendo assim, você concorda que seu perfil irá aparecer, publicamente e para todos jogadores, no ranking, e ainda concorda em se abster, sob quaisquer circunstâncias, de reclamações a respeito de constrangimento e exposição\n\nVOCÊ RECONHECE E CONCORDA QUE INDEPENDENTE DA SUA PONTUAÇÃO, SEU PERFIL APARECERÁ NO RANKING E DESSA FORMA, TODOS JOGADORES PODERÃO VER SUA POSIÇÃO E PONTUAÇÃO.\n\n<b>Com seu consentimento.</b>\n\nCom seu consentimento, podemos processar seus dados para finalidades adicionais, como usar sua localização de GPS para lhe mostrar eventos locais.'
            ) || ''
          }
        />
        <CardText
          b_container={b_containerName}
          b_str='12'
          title={`${t('QUEM PODE VER SEUS DADOS')}:`}
          text={
            t(
              'Além da Play2sell, seus dados podem ser acessados por outras pessoas nas seguintes situações:\n\nOUTROS JOGADORES E USUÁRIOS.\n\nOs recursos sociais são um componente essencial dos nossos jogos. Outros jogadores e usuários podem, por exemplo, ver seus dados de perfil, atividades no jogo, ler suas mensagens postadas, bem como, saber sua posição no Ranking.\n\nPARCEIROS QUE TRABALHAM PARA A PLAY2SELL.\n\nA Play2sell têm parceiros que realizam serviços para nós. Esses parceiros processam seus dados apenas de acordo com as instruções da Play2sell para fornecer o Serviço, por exemplo hospedagem, suporte ao jogador, publicidade, análise e prevenção de fraudes.\n\n<b>Outras empresas e órgãos públicos.</b>\n\nPara combater fraudes e atividades ilegais, podemos trocar dados com outras empresas e organizações e fornecê-los a órgãos públicos em resposta a requisições legais.\n\nTambém podemos divulgar seus dados, com seu consentimento, a fim de cumprir com a lei ou para proteger nossos direitos, propriedade ou segurança, dos nossos jogadores ou outros.\n\n<b>Parceiros de publicidade e mídias sociais.</b>\n\nO Serviço inclui recursos dos nossos parceiros, como ferramentas de interação de mídia social e publicidade no jogo. Uma lista desses parceiros está disponível em <www.p2s.me>. Esses parceiros podem acessar seus dados e operar de acordo com suas próprias políticas de privacidade. Incentivamos verificar as políticas de privacidade desses parceiros para saber mais sobre suas práticas referentes ao processamento de dados.'
            ) || ''
          }
        />
        <CardText
          b_container={b_containerName}
          b_str='13'
          title={t('TRANSFERÊNCIAS DE DADOS INTERNACIONAIS') || ''}
          text={
            t(
              'Nosso serviço é global por natureza e seus dados podem ser transferidos para qualquer lugar do mundo. Uma vez que países diferentes podem ter leis de proteção de dados diferentes do seu, tomamos medidas para garantir que hajam proteções adequadas em vigor para proteger seus dados, conforme explicado nesta Política. As proteções adequadas que nossos parceiros podem usar incluem cláusulas contratuais padrão aprovadas pela Comissão da UE e a Certificação de Proteção da Privacidade no caso de transferências para os EUA.\n\nSEUS DIREITOS E OPÇÕES\n\n<b>E-mails de escolha de não recebimento de materiais de marketing e outros tipos de marketing direto.</b>\n\nVocê pode optar por não receber nossas comunicações promocionais, como e-mails e SMS de marketing, seguindo as instruções contidas em tais comunicações.\n\n<b>Excluir publicidade direcionada.</b>\n\nVocê pode excluir a propaganda baseada em interesse nos aplicativos para celular verificando as configurações de privacidade do seu dispositivo Android ou iOS e selecionando “limitar o rastreamento de anúncios” (Apple iOS) ou “excluir anúncios baseados em interesses” (Android).\n\nPara excluir ofertas personalizadas no jogo, você pode usar as opções fornecidas nas configurações do jogo.\n\n<b>Acesse os dados pessoais que temos sobre você.</b>\n\nSe solicitado, forneceremos uma cópia dos seus dados pessoais em formato eletrônico.\n\n<b>Seus outros direitos.</b>\n\nVocê também tem o direito de corrigir e excluir seus dados, contestar ou restringir a forma como usamos ou compartilhamos seus dados. Você pode sempre retirar seu consentimento, por exemplo, desativando o compartilhamento de localização por GPS nas configurações do seu celular. Responderemos a todas as suas solicitações dentro de um prazo razoável.\n\nCOOKIES E TECNOLOGIAS SEMELHANTES\n\nAssim como para a maioria dos serviços on-line, nós e nossos parceiros usamos cookies e tecnologias similares para fornecer e personalizar o Serviço, analisar o uso, direcionar anúncios e evitar fraudes. Você pode desativar os cookies nas configurações do navegador, mas algumas partes do Serviço podem não funcionar corretamente.\n\nCOMO PROTEGEMOS SEUS DADOS?\n\n<b>Meios de segurança.</b>\n\nPara ajudar a garantir uma experiência segura para o jogador, estamos continuamente desenvolvendo e implementando medidas de segurança administrativas, técnicas e físicas para proteger seus dados contra o acesso não autorizado ou contra perda, uso indevido ou alteração.\n\n<b>Retenção de dados.</b>\n\nRetemos seus dados enquanto sua conta estiver ativa ou enquanto for necessário para lhe prestar o Serviço.  Periodicamente, por exemplo, desidentificaremos contas de jogo não utilizadas e, regularmente, revisaremos e desidentificaremos dados desnecessários.\nObserve que, mesmo se nos pedir para remover seus dados pessoais, manteremos seus dados conforme necessário para nossos interesses comerciais legítimos, como para cumprir com nossas obrigações legais, resolver disputas e fazer cumprir nossos contratos.\n\nORDEM DE AUTORIDADES COMPETENTES – REQUERIMENTOS LEGAIS\n\nA Play2sell coopera com as autoridades competentes e com terceiros para garantir o cumprimento das leis, salvaguardar a integridade e a segurança da plataforma e de seus usuários, impedir atividades ilegais, tais como lavagem de dinheiro, terrorismo e seu financiamento, fraudes e outros. Desta forma poderá revelar a informação pessoal, dados cadastrais, registros de acesso, dados de navegação etc., nos termos previstos na legislação brasileira.\n\nA Play2sell reserva-se o direito de repassar, a qualquer momento, a seu exclusivo critério e sem aviso ou consentimento prévio, quaisquer dados ou conteúdo de usuários para governos ou entidades, públicas ou privadas, com o intuito de cumprir a legislação vigente, ordens judiciais ou prevenir, interromper ou suportar a investigação ou julgamento de quaisquer atividades que possam ser consideradas ilegais, antiéticas, que infrinjam qualquer política da Play2sell ou que possa prejudicar qualquer pessoa ou instituição.\n\nLIMITES DE IDADE\n\nNão coletamos ou solicitamos intencionalmente dados pessoais, ou direcionamos propaganda baseada no interesse a menores de 16 anos de idade, tampouco permitimos conscientemente que essas pessoas utilizem nossos Serviços.  Não é permitido que menores de 16 anos nos enviem quaisquer dados, incluindo nome, endereço, número de telefone ou endereço de e-mail. Se tomarmos conhecimento de que coletamos dados pessoais relativos a uma pessoa menor de 16 anos, excluiremos esses dados o mais rápido possível.  Caso você desconfie que possamos ter informações pertencentes a um menor de 16 anos, entre em contato conosco imediatamente.\n\nFORO DE ELEIÇÃO\n\nAs partes elegem como competente para dirimir eventuais controvérsias que venham a surgir da interpretação e do cumprimento dos presentes Termos de Uso o Foro Central da São Paulo – SP.\n\nÚltima atualização em <b>05 de agosto de 2020</b>.'
            ) || ''
          }
        />
      </main>
      <Footer />
    </>
  );
};
export default PoliticaPrivacidade;
